export default function CsDarkWeb() {
  return (
    <h2>Cs Dark Web</h2>
  );
}
